import React from 'react';
import { IconButton, Badge, Tooltip } from '@mui/material';
import { Comment as CommentIcon } from '@mui/icons-material';

const WIPCommentIcon = ({
  commentCount = 0,
  onClick,
  hasUnresolved = false,
}) => {
  return (
    <Tooltip title={`${commentCount} comment${commentCount !== 1 ? 's' : ''}`}>
      <IconButton
        size="small"
        onClick={e => {
          e.stopPropagation();
          onClick();
        }}
        sx={{
          padding: '4px',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
      >
        <Badge
          badgeContent={commentCount}
          color={hasUnresolved ? 'error' : 'primary'}
          max={99}
        >
          <CommentIcon
            fontSize="small"
            sx={{
              color: commentCount > 0 ? '#4B68D4' : '#999',
            }}
          />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default WIPCommentIcon;

